import { nativeEnum, object, string, TypeOf } from 'zod';

/* ----------------------------- PlayerEventType ---------------------------- */

export enum PlayerEventType {
    Play = 'play',
    Playing = 'playing',
    Pause = 'pause',
    Seeked = 'seeked',
    Ended = 'ended',
}

/* ----------------------------- DURATION_REGEX ----------------------------- */

export const DURATION_REGEX =
    /^P(([0-9]+Y)?([0-9]+M)?([0-9]+W)?([0-9]+D)?(T([0-9]+H)?([0-9]+M)?([0-9]+(\.?[0-9]+)?S)?))?$/;

/* ----------------------------- PlayerEventBody ---------------------------- */

export const PlayerEventBody = object({
    entitlementId: string(),
    productId: string(),
    type: nativeEnum(PlayerEventType),
    elapsed: string().regex(DURATION_REGEX),
    duration: string().regex(DURATION_REGEX).optional(),
});

export type PlayerEventBody = TypeOf<typeof PlayerEventBody>;
